module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_05-71b000ff7853c539af0715b789131d9a.jpg";